import React from "react";

const PromoCard = ({ promo }) => {
  const {
    promo_name,
    description,
    banner_url,
    code,
    discount_value,
    type,
    currency,
  } = promo;

  return (
    <div className="promo-card">
      <div className="promo-banner">
        {banner_url ? (
          <img src={banner_url} alt={promo_name} />
        ) : (
          <div className="no-image">No Image</div>
        )}
        <span className="promo-discount">
          {type === "label"
            ? discount_value
            : type === "amount"
            ? `${currency} $${discount_value} off`
            : `${discount_value}% off`}
        </span>
      </div>

      <div className="promo-content">
        <h3>{promo_name}</h3>
        <p className="promo-desc">{description || "Limited time offer!"}</p>

        <div className="promo-details">
          <span className="promo-code">
            Code: <b>{code}</b>
          </span>
        </div>
      </div>
    </div>
  );
};

export default PromoCard;
